// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"6238d9ed","159":"33907e0e","408":"1c1cd80a","672":"5daf9ff8","833":"d4ca37a8"}[chunkId] + ".chunk.js";
};